import React from "react";
import { string } from "prop-types";

import ProfileContainer from "../../rows/ProfileContainer";
import ChangePassword from "../../molecules/ChangePassword";

const ChangePasswordPage = ({ currentPath }) => (
  <ProfileContainer type="change-password" hideTopAd={true} currentPath={currentPath}>
    {({ member }) => <ChangePassword member={member} />}
  </ProfileContainer>
);

ChangePasswordPage.propTypes = {
  currentPath: string,
};

export { ChangePasswordPage };
